import { lookupService } from '../../helpers/services/lookup.service'
import { sharedHelper } from '@/utils'

export const state = {
  roleDdl: [],
  userDdl: [],
  agentDdl: [],
  unlinkedAgentDdl: [],
  salesDocTypeDdl: [],
  areaCodeDdl: [],
  itemDdl: [],
  debtorDdl: [],
  salesDocLookup: [],
  taxDdl: [],
  permissions: [],
}

export const LOOKUP_MODULE = 'lookup'

// ACTIONS
export const LOOKUP_ROLE = 'lookupRole'
export const LOOKUP_USER = 'lookupUser'
export const LOOKUP_AGENT = 'lookupAgent'
export const LOOKUP_UNLINKED_AGENT = 'lookupUnlinkedAgent'
export const LOOKUP_PERMISSION = 'lookupPermission'
export const LOOKUP_SALES_DOC_TYPE = 'lookupSalesDocType'
export const LOOKUP_AREA_CODE = 'lookupAreaCode'
export const LOOKUP_ITEM = 'lookupItem'
export const LOOKUP_DEBTOR = 'lookupDebtor'
export const LOOKUP_SALES_DOC = 'lookupSalesDoc'
export const LOOKUP_TAX = 'lookupTax'

// MUTATIONS
const ROLE_SUCCESS = 'roleSuccess'
const ROLE_FAILED = 'roleFailed'
const USER_SUCCESS = 'userSuccess'
const USER_FAILED = 'userFailed'
const AGENT_SUCCESS = 'agentSuccess'
const AGENT_FAILED = 'agentFailed'
const UNLINKED_AGENT_SUCCESS = 'unlinkedAgentSuccess'
const UNLINKED_AGENT_FAILED = 'unlinkedAgentFailed'
const PERMISSION_SUCCESS = 'permissionSuccess'
const PERMISSION_FAILED = 'permissionFailed'
const SALES_DOC_TYPE_SUCCESS = 'salesDocTypeSuccess'
const SALES_DOC_TYPE_FAILED = 'salesDocTypeFailed'
const AREA_CODE_SUCCESS = 'areaCodeSuccess'
const AREA_CODE_FAILED = 'areaCodeFailed'
const ITEM_SUCCESS = 'itemSuccess'
const ITEM_FAILED = 'itemFailed'
const DEBTOR_SUCCESS = 'debtorSuccess'
const DEBTOR_FAILED = 'debtorFailed'
const SALES_DOC_LOOKUP_SUCCESS = 'salesDocLookupSuccess'
const SALES_DOC_LOOKUP_FAILED = 'salesDocLookupFailed'
const TAX_SUCCESS = 'taxSuccess'
const TAX_FAILED = 'taxFailed'

export const getters = {}

export const actions = {
  [LOOKUP_ROLE]({ commit }) {
    return lookupService
      .getLookupRoles()
      .then((result) => {
        commit(ROLE_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(ROLE_FAILED)
      })
  },
  [LOOKUP_USER]({ commit }) {
    return lookupService
      .getLookupUsers()
      .then((result) => {
        commit(USER_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(USER_FAILED)
      })
  },
  [LOOKUP_AGENT]({ commit }, { search } = {}) {
    return lookupService
      .getLookupAgents(search)
      .then((result) => {
        commit(AGENT_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(AGENT_FAILED)
      })
  },
  [LOOKUP_UNLINKED_AGENT]({ commit }, { excludeUserUuid } = {}) {
    return lookupService
      .getUnlinkedAgents(excludeUserUuid)
      .then((result) => {
        commit(UNLINKED_AGENT_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(UNLINKED_AGENT_FAILED)
      })
  },
  [LOOKUP_PERMISSION]({ commit }) {
    return lookupService
      .getAllPermissions()
      .then((result) => {
        commit(PERMISSION_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(PERMISSION_FAILED)
      })
  },
  [LOOKUP_SALES_DOC_TYPE]({ commit }) {
    return lookupService
      .getSalesDocTypes()
      .then((result) => {
        commit(SALES_DOC_TYPE_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(SALES_DOC_TYPE_FAILED)
      })
  },
  [LOOKUP_AREA_CODE]({ commit }) {
    return lookupService
      .getAreaCodes()
      .then((result) => {
        commit(AREA_CODE_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(AREA_CODE_FAILED)
      })
  },
  [LOOKUP_ITEM]({ commit }, { search } = {}) {
    return lookupService
      .getItems(search)
      .then((result) => {
        commit(ITEM_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(ITEM_FAILED)
      })
  },
  [LOOKUP_DEBTOR]({ commit }, { search } = {}) {
    return lookupService
      .getDebtors(search)
      .then((result) => {
        commit(DEBTOR_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(DEBTOR_FAILED)
      })
  },
  [LOOKUP_TAX]({ commit }) {
    return lookupService
      .getTaxes()
      .then((result) => {
        commit(TAX_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(TAX_FAILED)
      })
  },
  [LOOKUP_SALES_DOC]({ commit }, { type } = {}) {
    if (!type) {
      commit(SALES_DOC_LOOKUP_SUCCESS, [])
      return Promise.resolve()
    }
    return lookupService
      .getSalesDocsLookup(type)
      .then((result) => {
        commit(SALES_DOC_LOOKUP_SUCCESS, result?.data || [])
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(SALES_DOC_LOOKUP_FAILED)
      })
  },
}

export const mutations = {
  [ROLE_SUCCESS](state, p) {
    state.roleDdl = p
  },
  [ROLE_FAILED](state) {
    state.roleDdl = []
  },
  [USER_SUCCESS](state, p) {
    state.userDdl = p
  },
  [USER_FAILED](state) {
    state.userDdl = []
  },
  [AGENT_SUCCESS](state, p) {
    state.agentDdl = p
  },
  [AGENT_FAILED](state) {
    state.agentDdl = []
  },
  [UNLINKED_AGENT_SUCCESS](state, p) {
    state.unlinkedAgentDdl = p
  },
  [UNLINKED_AGENT_FAILED](state) {
    state.unlinkedAgentDdl = []
  },
  [PERMISSION_SUCCESS](state, p) {
    state.permissions = p
  },
  [PERMISSION_FAILED](state) {
    state.permissions = []
  },
  [SALES_DOC_TYPE_SUCCESS](state, p) {
    state.salesDocTypeDdl = p
  },
  [SALES_DOC_TYPE_FAILED](state) {
    state.salesDocTypeDdl = []
  },
  [AREA_CODE_SUCCESS](state, p) {
    state.areaCodeDdl = p
  },
  [AREA_CODE_FAILED](state) {
    state.areaCodeDdl = []
  },
  [ITEM_SUCCESS](state, p) {
    state.itemDdl = p
  },
  [ITEM_FAILED](state) {
    state.itemDdl = []
  },
  [DEBTOR_SUCCESS](state, p) {
    state.debtorDdl = p
  },
  [DEBTOR_FAILED](state) {
    state.debtorDdl = []
  },
  [SALES_DOC_LOOKUP_SUCCESS](state, p) {
    state.salesDocLookup = p
  },
  [SALES_DOC_LOOKUP_FAILED](state) {
    state.salesDocLookup = []
  },
  [TAX_SUCCESS](state, p) {
    state.taxDdl = p
  },
  [TAX_FAILED](state) {
    state.taxDdl = []
  },
}
